"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  root: {
    zIndex: 10,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.5)',
    transition: 'opacity 0.3s'
  },
  visible: {
    opacity: 1
  },
  hidden: {
    opacity: 0
  },
  content: {
    position: 'absolute',
    top: '150px',
    left: '50%',
    transform: 'translate(-50%, 0)',
    background: _styles.colors.white,
    border: "1px solid ".concat(_styles.colors.gray),
    padding: '30px',
    maxHeight: '85vh',
    width: function width(_ref) {
      var size = _ref.size;
      if (size === 'small') return '400px';
      if (size === 'large') return '700px';
      return '500px';
    },
    transition: 'all 0.3s'
  },
  contentOffset: {
    transform: 'translate(-50%, -40%)'
  }
};
var _default = styles;
exports["default"] = _default;